<template>
    <Dialog 
          :header="formMode == 'edit' ? 'Chỉnh sửa loại sự cố': 'Tạo mới loại sự cố'"
          :visible.sync="displayDialog"
          :contentStyle="{overflow: 'visible'}"
          :style="{width: '50vw'}"
          :class="'popup-dialog'"
          :modal="true"
        >
        <div class="p-fluid">
            <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <label>Mã loại sự cố <span class="error">*</span></label>
                </div>
                <div class="p-field">
                    <InputText disabled="true" id="code" type="text" v-model="code"/>
                </div>
            </div>

            <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <label>Loại sự cố<span class="error">*</span></label>
                </div>
                <div class="p-field">
                    <InputText maxlength="255" id="name" type="text" v-model="name" :placeholder="'Nhập loại sự cố'"/>
                    <small v-if="validationErrors && validationErrors['name']"
                        class="p-invalid" >{{validationErrors['name']}}</small>
                    <small v-if="name_exists"
                    class="p-invalid" >Loại sự cố bị trùng</small>
                </div>
            </div>
            <div class="p-col-12 form-popup-custom">
               <div class="p-field">
                    <label >Thứ tự hiển thị</label>
                    <div class="input-number-inline">
                        <InputNumber :min="-1"  id="ordering" v-model="ordering" showButtons />
                    </div>
               </div>
            </div>

            <div class="p-col-12 form-popup-custom">
                <div class="p-field">
                    <div class="p-field-checkbox">
                        <Checkbox  v-model="status" :binary="true"/>
                        <label >Hiển thị sử dụng</label>
                    </div>
                </div>
            </div>
           
        </div>
        <template #footer>
            <Button :disabled="submitForm" class="p-button-success"  :label="formMode == 'edit' ? 'Lưu' : 'Tạo'" @click="saveData" />
        </template>
      </Dialog>
</template>

<script>
import DataServices from '@/core/DataServices'

export default {
  props: {
    show: Boolean,
    mode: String,
    modelName: String,
    model: Object
  },
  data() {
    return {
        code: '',
        name: '',
        status: true,
        displayDialog: this.show,
        validationErrors: {},
        name_exists: false,
        submitForm: false,
        ordering: 1
    }
  },
  created() {
    this.formMode = this.mode;
    if (this.formMode === 'edit'  && this.model !== undefined && this.model !== null && Object.entries(this.model).length) {
      this.code = this.model.code;
      this.name = this.model.name;
      this.ordering = this.model.ordering;
      this.status = this.model.status > 0;
    }
  },
  methods: {
    async validateData() {
        this.validationErrors = {};
        if (this.name === undefined || this.name === "") this.validationErrors['name'] = 'Nhập loại sự cố';
        this.name_exists = await this.checkName();
    },
    async checkName() {
        this.name = this.name.trim();
        if (this.name !== undefined && this.name !== "") {
            var where = { name: {'_ilike': this.name} }
            if (this.model !== undefined) where = Object.assign(where, {id: {'_neq': this.model.id}})
            var data = await DataServices.getList(this.modelName, {"fields": "id", "variables": JSON.stringify({where_key: where})});
            return data && data[Object.keys(data)].length > 0
        }
    },
    async getCode() {
        var number = 1;
        var variables = {
            where_key: {
                status: {'_in': [0, 1]}
            },
            orderBy: {
                id: 'desc'
            },
            limit: 1
        }
        var data = await DataServices.getList('type_violation', {"variables": JSON.stringify(variables), 'fields': 'code'});
        var list = data[Object.keys(data)];
        if (list != null && Object.keys(list).length > 0) {
            var code = list[0].code;
            code = code.substring(4);
            number += parseInt(code);
        }
        return 'RPT' + this.$myConstants.autoGenerateZero(number);
    },
    async saveData() {
        this.submitForm = true;
        await this.validateData();
        if (!this.name_exists && Object.entries(this.validationErrors).length === 0) {
            if (this.formMode === 'add') this.code = await this.getCode();
            if (this.code.length > 0) {
                var params = {
                    'code': this.code,
                    'name': this.name,
                    'ordering': this.ordering,
                    'status': this.status ? 1 : 0
                }
                if (this.formMode === 'add') {
                    params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() })
                    params = Object.assign(params, { 'created_at': this.$myConstants.currentDate() })
                    await DataServices.insertData(this.modelName, {"variables": JSON.stringify({objects: params})});
                    this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Tạo mới thành công', life: 3000 })
                    this.displayDialog = false;
                    this.$emit('refresh');
                } else {
                    params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() })
                    await DataServices.updateData(this.modelName, {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.model.id }}})});
                    this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
                    this.displayDialog = false;
                    this.$emit('refresh');
                }
            }
        } else this.submitForm = false;
    }
  }
}
</script>

<style lang="scss" scoped>
</style>